module.exports = __webpack_public_path__ + "resources/img/main01_gov.44a73df9e5f9a378a925a238568ca768.jpg";